import PendingOrdersList from './PendingOrdersList';

export default PendingOrdersList;
